/**
 * main.ts
 *
 * Entry point for client-v2. Bootstraps the app-root Lit component.
 * Service initialization and other global setup happens here.
 */

// First, so routing works in browsers without URLPattern (Safari before 26).
import './polyfills.js';
// Poster-style type, bundled so the offline app keeps it.
import '@fontsource/archivo/400.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/800.css';
import '@fontsource/archivo-black/400.css';
import '@fontsource/dm-mono/400.css';
import '@fontsource/dm-mono/500.css';
import './ui/styles/theme.css';
import './ui/components/shell/app-root.js';
import { OptionsService } from './ui/services/options.js';
import { applyDocumentOptions } from './ui/styles/theme.js';
import { installPreventDoubleTap } from './utils/prevent-double-tap.js';
import { startSync } from './ui/services/sync-instance.js';

applyDocumentOptions(new OptionsService().load());
installPreventDoubleTap();
// Signed-in players' progress, saves, replays, and drafts follow them between devices.
startSync();

// Colyseus room inspector and network simulator, opt-in for development:
// VITE_COLYSEUS_DEBUG=true pnpm dev
if (import.meta.env.DEV && import.meta.env.VITE_COLYSEUS_DEBUG === 'true') {
  void import('@colyseus/sdk/debug');
}

// Offline app shell and "new version" prompt (the service worker only exists
// in production builds).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void import('./pwa/register-sw.js').then(({ registerServiceWorker }) => registerServiceWorker());
}
